var base = require("base/js/search/search");
var searchFilter = require("./searchFilter");

function handleRefinements($results) {
    // Save the open/closed state of each refinement in each container
    var refinementStates = {
        "filter-container": {},
        "filter-header-desktop": {},
        "filter-header-mobile": {},
        "mobile-card-body": {},
    };

    // Save active class in containers
    var activeFilterHeaderDesktop = $(
        "#filter-header-container.refinements-desktop"
    ).hasClass("active");
    var activeFilterHeaderMobile = $(
        "#filter-header-container.refinements-mobile"
    ).hasClass("active");

    // Save current state of each refinement for each container
    $("#filter-container .refinement").each(function () {
        var dataName = $(this).data("name");
        if (dataName) {
            refinementStates["filter-container"][dataName] = {
                expanded:
                    $(this).find(".card-header").attr("aria-expanded") ===
                    "true",
                show: $(this).find(".card-body").hasClass("show"),
                active: $(this).hasClass("active"),
            };
        }
    });

    // Desktop filter-header-container
    $("#filter-header-container.refinements-desktop .refinement").each(
        function () {
            var dataName = $(this).data("name");
            if (dataName) {
                var refinementClass =
                    "refinement-header-" +
                    dataName.toLowerCase().replace(/ /g, "-");
                refinementStates["filter-header-desktop"][dataName] = {
                    expanded:
                        $(this).find(".card-header").attr("aria-expanded") ===
                        "true",
                    show: $(this)
                        .find("." + refinementClass)
                        .hasClass("show"),
                    active: $(this).hasClass("active"),
                };
            }
        }
    );

    // Mobile filter-header-container
    $("#filter-header-container.refinements-mobile .refinement").each(
        function () {
            var dataName = $(this).data("name");
            if (dataName) {
                var refinementClass =
                    "refinement-header-" +
                    dataName.toLowerCase().replace(/ /g, "-");
                refinementStates["filter-header-mobile"][dataName] = {
                    expanded:
                        $(this).find(".card-header").attr("aria-expanded") ===
                        "true",
                    show: $(this)
                        .find("." + refinementClass)
                        .hasClass("show"),
                    active: $(this).hasClass("active"),
                };
            }
        }
    );

    // Save mobile-card-body states
    var mobileCardBodyStates = {};
    $(".mobile-card-body .card-body").each(function () {
        var refinementId = $(this).attr("id");
        if (refinementId) {
            mobileCardBodyStates[refinementId] = {
                show: $(this).hasClass("show"),
                expanded: $(this).attr("aria-expanded") === "true",
            };
        }
    });

    // Update refinement content in all three containers
    var $newRefinements = $results.find(".refinements");

    $("#filter-container .refinement .card-body").each(function () {
        var refinementId = $(this).attr("id");
        if (refinementId) {
            var $newCardBody = $newRefinements.find("#" + refinementId);
            if ($newCardBody.length) {
                $(this).html($newCardBody.html());
            }
        }
    });

    $(
        "#filter-header-container.refinements-desktop .refinement .card-body"
    ).each(function () {
        var refinementId = $(this).attr("id");
        if (refinementId) {
            var $newCardBody = $newRefinements.find("#" + refinementId);
            if ($newCardBody.length) {
                $(this).html($newCardBody.html());
            }
        }
    });

    $(
        "#filter-header-container.refinements-mobile .refinement .card-body"
    ).each(function () {
        var refinementId = $(this).attr("id");
        if (refinementId) {
            var $newCardBody = $newRefinements.find("#" + refinementId);
            if ($newCardBody.length) {
                $(this).html($newCardBody.html());
            }
        }
    });

    // mobile-card-body - Update directly since it's a separate container
    var $newMobileCardBody = $results.find(".mobile-card-body");
    if ($newMobileCardBody.length > 0) {
        // If there's a new mobile-card-body in the response, update the content
        $(".mobile-card-body .card-body").each(function () {
            var refinementId = $(this).attr("id");
            if (refinementId) {
                var $newCardBody = $newMobileCardBody.find("#" + refinementId);
                if ($newCardBody.length) {
                    // Update only the inner content (ul.values)
                    var $newValues = $newCardBody.find("ul.values");
                    if ($newValues.length) {
                        $(this).find("ul.values").replaceWith($newValues);
                    }
                }
            }
        });
    } else {
        // If there's no mobile-card-body in the response, update from refinements
        $(".mobile-card-body .card-body").each(function () {
            var refinementId = $(this).attr("id");
            if (refinementId) {
                var $newCardBody = $newRefinements.find("#" + refinementId);
                if ($newCardBody.length) {
                    var $newValues = $newCardBody.find("ul.values");
                    if ($newValues.length) {
                        $(this).find("ul.values").replaceWith($newValues);
                    }
                }
            }
        });
    }

    // Restore open/closed states in each container
    // filter-container
    $("#filter-container .refinement").each(function () {
        var dataName = $(this).data("name");
        if (dataName && refinementStates["filter-container"][dataName]) {
            var state = refinementStates["filter-container"][dataName];
            if (state.active) {
                $(this).addClass("active");
            }
            $(this)
                .find(".card-header")
                .attr("aria-expanded", state.expanded ? "true" : "false");
            if (state.show) {
                $(this).find(".card-body").addClass("show");
            } else {
                $(this).find(".card-body").removeClass("show");
            }
        }
    });

    // filter-header-container desktop - Keep active class in the container
    if (activeFilterHeaderDesktop) {
        $("#filter-header-container.refinements-desktop").addClass("active");
    }

    // Restore states for each refinement in filter-header-container desktop
    $("#filter-header-container.refinements-desktop .refinement").each(
        function () {
            var dataName = $(this).data("name");
            if (
                dataName &&
                refinementStates["filter-header-desktop"][dataName]
            ) {
                var state = refinementStates["filter-header-desktop"][dataName];

                // Keep active class
                if (state.active) {
                    $(this).addClass("active");
                }

                // Restore expanded state
                $(this)
                    .find(".card-header")
                    .attr("aria-expanded", state.expanded ? "true" : "false");
                var refinementClass =
                    "refinement-header-" +
                    dataName.toLowerCase().replace(/ /g, "-");
                if (state.show) {
                    $(this)
                        .find("." + refinementClass)
                        .addClass("show");
                } else {
                    $(this)
                        .find("." + refinementClass)
                        .removeClass("show");
                }
            }
        }
    );

    // filter-header-container mobile - Keep active class in the container
    if (activeFilterHeaderMobile) {
        $("#filter-header-container.refinements-mobile").addClass("active");
    }

    // Restaurar estados para cada refinamiento en filter-header-container mobile
    $("#filter-header-container.refinements-mobile .refinement").each(
        function () {
            var dataName = $(this).data("name");
            if (
                dataName &&
                refinementStates["filter-header-mobile"][dataName]
            ) {
                var state = refinementStates["filter-header-mobile"][dataName];
                // Keep active class
                if (state.active) {
                    $(this).addClass("active");
                }
                // Restore expanded state
                $(this)
                    .find(".card-header")
                    .attr("aria-expanded", state.expanded ? "true" : "false");
                var refinementClass =
                    "refinement-header-" +
                    dataName.toLowerCase().replace(/ /g, "-");
                if (state.show) {
                    $(this)
                        .find("." + refinementClass)
                        .addClass("show");
                } else {
                    $(this)
                        .find("." + refinementClass)
                        .removeClass("show");
                }
            }
        }
    );
    $(".mobile-card-body .card-body").each(function () {
        var refinementId = $(this).attr("id");
        if (refinementId && mobileCardBodyStates[refinementId]) {
            var state = mobileCardBodyStates[refinementId];
            if (state.show) {
                $(this).addClass("show");
            } else {
                $(this).removeClass("show");
            }
            $(this).attr("aria-expanded", state.expanded ? "true" : "false");
        }
    });
}

function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        ".refinements": handleRefinements,
    };

    // Update DOM elements that do not require special handling
    [
        ".grid-header",
        ".header-bar",
        ".header.page-title",
        ".product-grid",
        ".show-more",
        ".filter-bar",
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

function hideFilter() {
    const filterContainer = document.querySelector("#refinement-bar");
    const body = document.querySelector("#body-scroll");
    filterContainer.style.display = "none";
    body.classList.remove("scroll-none");
}

function stickyFiltersOnScroll() {
    var $header = $(".header.container");
    var $filters = $(".custom-filters-container");
    var $mobileCardsFilters = $(".mobile-card-body");
    var $productGrid = $(".product-grid");
    if ($header.length === 0 || $filters.length === 0) return;

    function isMobile() {
        return window.innerWidth < 768;
    }

    function getCollisionPoint() {
        var headerHeight = $header.outerHeight();
        if (isMobile()) {
            if ($productGrid.length === 0) return null;
            var gridOffsetTop = $productGrid.offset().top;
            return gridOffsetTop - headerHeight;
        } else {
            var filtersOffsetTop = $filters.offset().top;
            return filtersOffsetTop - headerHeight;
        }
    }

    var collisionPoint = getCollisionPoint();
    var lastState = null;
    //Recalculate collision point on resize
    $(window).on("resize", function () {
        collisionPoint = getCollisionPoint();
        checkScroll();
    });

    function checkScroll() {
        var scrollTop = $(window).scrollTop();
        // If there is no collision point (for example, the grid is missing in mobile), do nothing
        if (collisionPoint === null) return;

        if (scrollTop >= collisionPoint) {
            if (lastState !== "fixed") {
                $filters.addClass("fixed-filters");
                $mobileCardsFilters.addClass("fixed-cards-body");
                $mobileCardsFilters.addClass("slide-down");
                $filters.addClass("slide-down");
                setTimeout(function () {
                    $filters.removeClass("slide-down");
                    $mobileCardsFilters.removeClass("slide-down");
                }, 350);
                lastState = "fixed";
            }
        } else {
            if (lastState !== "normal") {
                $filters.removeClass("fixed-filters slide-down");
                $mobileCardsFilters.removeClass("fixed-cards-body slide-down");
                lastState = "normal";
            }
        }
    }

    // Optimization: only one active scroll handler
    var ticking = false;
    $(window).on("scroll", function () {
        if (!ticking) {
            window.requestAnimationFrame(function () {
                checkScroll();
                ticking = false;
            });
            ticking = true;
        }
    });

    // Initial state on load
    checkScroll();
}
/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $("<div>").append($(response));
    var sortOptions = $tempDom
        .find(".grid-footer")
        .data("sort-options").options;
    sortOptions.forEach(function (option) {
        $("option." + option.id).val(option.url);
    });
}
/**
 * Function to position the mobile-card-body element below .searchRefinementsMobile .refinements-mobile
 */
function positionRefinementElements() {
    if (window.innerWidth >= 768) return;
    
    // Function to adjust the position of the mobile-card-body
    function adjustMobileCardBodyPosition() {
        // Get the refinements-mobile element
        const refinementsContainer = $('#searchRefinementsMobile .refinements-mobile');
        
        if (refinementsContainer.length === 0) return;
        
        // Get the mobile-card-body element
        const mobileCardBody = $('.mobile-card-body');
        
        if (mobileCardBody.length === 0) return;
        
        // Calculate the position of the refinements-mobile container
        const containerRect = refinementsContainer[0].getBoundingClientRect();
        const containerBottom = containerRect.bottom;
        
        // Set the top position of the mobile-card-body to be just below the refinements-mobile container
        // Adjust the position considering the page scroll
        mobileCardBody.css({
            'top': (containerBottom + window.scrollY) + 'px',
            'position': 'absolute',
            'z-index': '1000',
            'width': '100%',
            'left': '0'
        });
    }
    
    $(document).on('click', '#searchRefinementsMobile .refinement .card-header', function(event) {
        // Wait a little bit for Bootstrap to finish showing/hiding the panel
        setTimeout(adjustMobileCardBodyPosition, 10);
    });
    
    // Also adjust the position when the window size changes
    $(window).on('resize', adjustMobileCardBodyPosition);
    

    adjustMobileCardBodyPosition();
}

function mobileCollapsibleHeaderElementControl() {
    if (window.innerWidth >= 768) return;
    const filterHeaders = $(
        '#filter-header-container.refinements-mobile .card-header[data-toggle="collapse"]'
    );
    const collapsibleBodies = $(
        ".mobile-card-body .card-body.content.value.collapse"
    );
    const closeButtons = $(
        '.mobile-card-body .card-body-header .close[data-toggle="collapse"]'
    );
    function closeOtherCollapsibles(currentTarget) {
        collapsibleBodies.each(function () {
            // If it's not the target element and it's open, close it
            if (!$(this).is(currentTarget) && $(this).hasClass("show")) {
                $(this).removeClass("show");
                $(this).attr("aria-expanded", "false");

                // Find and update the corresponding header
                const refinementClass = $(this)
                    .attr("id")
                    .replace("refinement-", "");
                const headerSelector = `.refinement-${refinementClass}-divider .card-header`;
                $(headerSelector).attr("aria-expanded", "false");
            }
        });
    }
    // Override click behavior on filter headers
    filterHeaders.on("click", function (e) {
        setTimeout(() => {
            const targetSelector = $(this).attr("data-target");
            if (!targetSelector) return;

            const targetElements = $(targetSelector);

            if ($(this).attr("aria-expanded") === "true") {
                closeOtherCollapsibles(targetElements);
            }
        }, 50);
    });
    closeButtons.on("click", function (e) {
        setTimeout(() => {
            const targetSelector = $(this).attr("data-target");
            if (!targetSelector) return;

            const targetElements = $(targetSelector);

            targetElements.removeClass("show");
            targetElements.attr("aria-expanded", "false");

            const headerSelector =
                targetSelector.replace(".refinement-header-", ".refinement-") +
                "-divider .card-header";
            $(headerSelector).attr("aria-expanded", "false");
        }, 50);
    });

    // Special fix for Safari iOS
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        // Force state synchronization when clicking on any collapsible element
        $(".collapse").on("shown.bs.collapse", function () {
            const currentId = $(this).attr("id");

            $(".collapse.show").each(function () {
                if (
                    $(this).attr("id") !== currentId &&
                    $(this).closest(".mobile-card-body").length > 0
                ) {
                    $(this).removeClass("show");
                    $(this).attr("aria-expanded", "false");

                    if ($(this).attr("id")) {
                        const refinementClass = $(this)
                            .attr("id")
                            .replace("refinement-", "");
                        const headerSelector = `.refinement-${refinementClass}-divider .card-header`;
                        $(headerSelector).attr("aria-expanded", "false");
                    }
                }
            });
        });
    }
}

module.exports = {
    onInit: function () {
        stickyFiltersOnScroll();
        mobileCollapsibleHeaderElementControl();
        positionRefinementElements();
    },
    sort: function () {
        // Handle sort order menu selection
        $(".container").on("change", "[name=sort-order]", function (e) {
            e.preventDefault();

            $.spinner().start();
            localStorage.setItem("selectedSortingURL", this.value);
            $(this).trigger("search:sort", this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: "GET",
                success: function (response) {
                    $(".product-grid").empty().html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },
    toggleRefinementState: function () {
        $(document).on("click", ".refinements .refinement", function (e) {
            const $allRefinements = $(".refinements .refinement").not(this);
            $allRefinements
                .removeClass("active")
                .find(".card-header")
                .attr("aria-expanded", "false")
                .find(".title")
                .attr("aria-expanded", "false");
        });
    },
    ApplyFilter: function () {
        $(".container").on(
            "click",
            ".refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .color-attribute, .mobile-card-body li button, .filter-tag-container .filter-tag",
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger("search:filter", e);
                var attributeId = "#" + $(this).find("span").last().attr("id");
                var sortingSelectedUrl;
                if (localStorage.getItem("selectedSortingURL")) {
                    sortingSelectedUrl =
                        localStorage.getItem("selectedSortingURL");
                } else {
                    sortingSelectedUrl = $(
                        'select[name="sort-order"] option:selected'
                    ).val();
                }
                if (!sortingSelectedUrl) {
                    sortingSelectedUrl = $(
                        'select[name="sort-order"] option'
                    )[0].value;
                }
                var pagePositionParams = new URL(window.location.href);
                var start = pagePositionParams.searchParams.get("start");
                var sz = pagePositionParams.searchParams.get("sz");
                var pagePositionsQueryString = "";
                if (start && sz) {
                    var windowWidth = $(window).width();
                    var showInMobile = $(".grid-footer").data("product-show-mobile");
                    var showInDesktop = $(".grid-footer").data("product-show-desktop");
                    var pageSize = windowWidth < 768 ? showInMobile : showInDesktop;
                    pagePositionsQueryString = `&start=${0}&sz=${pageSize}`;
                }

                var sortingSelected = new URL(sortingSelectedUrl);
                var srule = sortingSelected.searchParams.get("srule");
                var filtersToSortings = searchFilter.extractFilters(
                    $(this).data("href")
                );
                searchFilter.updateSelectOptions(
                    $("select[name=sort-order]"),
                    filtersToSortings
                );
                // Verify if the clicked element is in #filter-container and store it in a variable
                var clickedElementInFilterContainer =
                    $(this).closest("#filter-container").length > 0;

                var filterUrl =
                    $(this).data("href") +
                    `&srule=${srule}${pagePositionsQueryString}`;
                $.ajax({
                    url: filterUrl,
                    data: {
                        page: $(".grid-footer").data("page-number"),
                        selectedUrl: $(this).data("href"),
                    },
                    method: "GET",
                    success: function (response) {
                        var $activeRefinement = $(
                            "#filter-header-container.refinements-desktop .refinement.active"
                        ).data("name");
                        parseResults(response);
                        stickyFiltersOnScroll();

                        var principalFilterTagsContainer = $(".custom-filters-container.desktopFilters .filter-tag-container")
                        // Keep the tags in the original container and add a copy to custom-tags-container
                        $(".custom-tags-container").empty().append(principalFilterTagsContainer.clone());

                        // Apply logic to #filter-header-container only if the button is not in #filter-container
                        if (!clickedElementInFilterContainer) {
                            $(
                                "#filter-header-container.refinements-desktop .refinement"
                            ).each(function () {
                                if ($(this).data("name") == $activeRefinement) {
                                    $(this)
                                        .addClass("active")
                                        .find(".card-header")
                                        .attr("aria-expanded", "true")
                                        .find(".title")
                                        .attr("aria-expanded", "true");
                                    $(this).find(".card-body").addClass("show");
                                } else {
                                    $(this)
                                        .removeClass("active")
                                        .find(".card-header")
                                        .attr("aria-expanded", "false")
                                        .find(".title")
                                        .attr("aria-expanded", "false");
                                    $(this)
                                        .find(".card-body")
                                        .removeClass("show");
                                }
                            });
                        }
                        $(attributeId).parent("button").focus();
                        $(".refinements").each(function () {
                            var filterName = $($(this)).data("name");
                            if (filterName == "Precio") {
                                $(this).find(".r-price").addClass("selected");
                            }

                            $(
                                `.refinement.refinements-desktop[data-name="${filterName}"] .card-header`
                            ).attr("aria-expanded", "true");
                            $(
                                `.refinement.refinements-desktop[data-name="${filterName}"] .card-body`
                            ).addClass("show");
                        });

                        $(
                            ".refinements.refinements-desktop .refinement-info"
                        ).on("click", function () {
                            var $button = $(this).find(
                                ".filter-collapse-button"
                            );

                            if ($button.hasClass("collapsed")) {
                                $button.removeClass("collapsed");
                            } else {
                                $button.addClass("collapsed");
                            }
                        });

                        $("#close-mobile-filter").on("click", function () {
                            hideFilter();
                        });
                        function isMobile() {
                            return window.innerWidth < 768;
                        }
                        if (isMobile()) {
                            var sortingAndFiltersUrl = $(
                                '.mobile-sort select[name="sort-order"] option:selected'
                            ).val();
                            if (!sortingAndFiltersUrl) {
                                sortingAndFiltersUrl = $('.mobile-sort select[name="sort-order"] option').length ? $('.mobile-sort select[name="sort-order"] option')[0].value : '';
                            }
                        }else{
                            var sortingAndFiltersUrl = $(
                                '.desktop-sort select[name="sort-order"] option:selected'
                            ).val();
                            if (!sortingAndFiltersUrl) {
                                sortingAndFiltersUrl = $('.desktop-sort select[name="sort-order"] option').length ? $('.desktop-sort select[name="sort-order"] option')[0].value : '';
                            }
                        }
                        if (sortingAndFiltersUrl){
                            var filtersUrl = new URL(sortingAndFiltersUrl);
                            const newUrl =
                                window.location.origin +
                                window.location.pathname +
                                filtersUrl.search;
                            history.replaceState(null, "", newUrl);
                        }
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent("button").focus();
                    },
                });
            }
        );
    },
    showMore: function () {
        function handlePagination(url) {
            if (!url) return;
            
            $.spinner().start();
            $.ajax({
                url: url,
                data: { selectedUrl: url },
                method: "GET",
                success: function (response) {
                    var filtersUrl = new URL(url);
                    const newUrl =
                        window.location.origin +
                        window.location.pathname +
                        filtersUrl.search;
                    history.replaceState(null, "", newUrl);

                    $(".custom-product-list").remove();
                    $(".grid-footer").replaceWith(response);
                    updateSortOptions(response);
                    $.spinner().stop();
                },
                error: function (e) {
                    $.spinner().stop();
                },
            });
        }

        // Handle clicks on any pagination element
        $(".container").on("click", ".page-link", function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Do nothing if element is disabled
            if ($(this).hasClass('disabled')) {
                return;
            }
            
            var pageUrl = $(this).data("url");
            $(this).trigger("search:page", e);
            handlePagination(pageUrl);
        });

        // Keep compatibility with old buttons
        // Show more products
        $(".container").on("click", ".show-more button", function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Do nothing if button is disabled
            if ($(this).prop('disabled')) {
                return;
            }
            
            var showMoreUrl = $(this).data("url");
            $(this).trigger("search:showMore", e);
            handlePagination(showMoreUrl);
        });

        // Show previous page of products
        $(".container").on("click", ".show-prev button", function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Do nothing if button is disabled
            if ($(this).prop('disabled')) {
                return;
            }
            
            var showPrevUrl = $(this).data("url");
            $(this).trigger("search:showMore", e);
            handlePagination(showPrevUrl);
        });
    },
    closeRefinements: base.closeRefinements,
    filter: base.filter,
    resize: base.resize,
    showContentTab: base.showContentTab,
};
